import {
  requiredString,
  optionalString,
  optionalUrl,
  optionalEmail,
  optionalPhone,
  optionalFile,
  createResourceSchema
} from './common'

export const facilitySchema = createResourceSchema({
  name: requiredString('Name'),
  description: optionalString,
  opening_hours: optionalString,
  link: optionalUrl,
  email: optionalEmail,
  phone: optionalPhone,
  header_image: optionalFile
})
